<template>
  <div class="about-Pn">
    <div class="back-img" ref="imgHeight">
      <div class="title-nav">
        <el-row :gutter="20">
          <el-col
            :class="{ active: index === isActive }"
            :key="index"
            :span="2"
            @click.native="handleClick(index)"
            v-for="(item, index) in navData"
            >{{ item.value }}</el-col
          >
        </el-row>
      </div>
    </div>
    <div
      class="aboutus"
      :style="{
        width:
          isShow == 4 && (imgData.length == 4 || imgData.length == 2)
            ? '60%'
            : '85%'
      }"
    >
      <template v-if="isShow == 0">
        <div class="about-msg">
          <img alt="企业简介" class="img-qy" :src="content.img" />
          <div :class="{ anima: isAnima }" class="content right-css">
            <h2>企业简介</h2>
            <div class="line mt-30"></div>
            <transition name="bounce">
              <div class="first" v-html="content.content"></div>
            </transition>
          </div>
        </div>
      </template>
      <template v-if="isShow == 1">
        <div class="team-group">
          <div class="group-item">
            <img alt="胡象应先生" src="@image/h.png" />
            <div class="job-name">
              <div>
                <span>胡象应先生</span>
                <span class="post">董事长</span>
              </div>
              <p>
                清华大学毕业。10余年国有银行、10余年商用车融资服务行业从业及管理经历。凭借丰富的金融行业经验及对行业的深刻洞察，
                2015年9月，胡象应先生牵头组建湖北品农商用车服务有限公司，任董事长至今。
              </p>
            </div>
          </div>
          <div class="group-item">
            <img alt="杨勇先生" src="@image/y.png" />
            <div class="job-name">
              <div>
                <span>杨勇先生</span>
                <span class="post">总经理</span>
              </div>
              <p>
                中南财经政法大学毕业。8年的高校教学和学报编辑经历，20余年股份制银行支行行长、分行营业部总经理、分行办公室主任，二级分行行长的工作经验。2015年9月任湖北品农商用车服务有限公司总经理至今。
              </p>
            </div>
          </div>
          <div class="group-item">
            <img alt="汪新民先生" src="@image/w.png" />
            <div class="job-name">
              <div>
                <span>汪新民先生</span>
                <span class="post">副总经理</span>
              </div>
              <p>
                华中科技大学电子工程本科、清华大学汽车信息工程研究生毕业。20余年软件开发管理经历，参与国内多个互联网重点项目的开发，高校电子控制系兼职教授。2015年9月任湖北品农商用车服务有限公司副总经理至今。
              </p>
            </div>
          </div>
          <div class="group-item">
            <img alt="吴世云先生" src="@image/wsy.png" />
            <div class="job-name">
              <div>
                <span>吴世云先生</span>
                <span class="post">副总经理</span>
              </div>
              <p>
                清华大学毕业。10余年设计院、商业地产工作经历，10余年商用车行业从业及管理经历。2015年9月任湖北品农商用车服务有限公司副总经理、市场营销负责人至今。
              </p>
            </div>
          </div>
          <!-- <div class="group-item">
            <img alt="马雪峰女士" src="@image/m.png" style="left:35px" />
            <div class="job-name">
              <div>
                <span>马雪峰女士</span>
                <span class="post">总经理助理</span>
              </div>
              <p>
                中南财经政法大学会计本科、华中师范大学区域经济学研究生毕业。近20年合资企业从业及管理经历。2017年6月加入湖北品农商用车服务有限公司，2020年6月任公司总经理助理至今。
              </p>
            </div>
          </div> -->
        </div>
      </template>

      <template v-if="isShow == 2">
        <div class="img-line">
          <img alt="组织架构" class="imgs" :src="teamImg.img" />
        </div>
      </template>

      <template v-if="isShow == 3">
        <div class="time-line" ref="time_line">
          <div v-for="(o, index) in develope" :key="index">
            <div
              :class="{ yearCss: o.btn }"
              @click="handerYear(index)"
              class="time-line-div"
              style="cursor:pointer"
            >
              <p class="tooptip" ref="circular">{{ o.title }}</p>
              <p class="msg">{{ o.msg }}</p>
            </div>
            <div class="img-dotted" ref="dotted"></div>
            <template v-if="o.btn">
              <div v-for="(item, i1) in o.children" :key="i1">
                <div class="img-dotted" ref="dotted"></div>
                <div class="time-line-div">
                  <p class="timeDate">{{ item.time }}</p>
                  <p class="circular" ref="circular"></p>
                  <p class="message" :class="{ red_msg: item.is_main == 1 }">
                    {{ item.msg }}
                  </p>
                </div>
                <div class="img-dotted" ref="dotted"></div>
              </div>
            </template>
          </div>
        </div>
      </template>

      <template v-if="isShow == 4">
        <div class="img-box">
          <div
            class="box-item"
            v-for="(item, i1) in imgData.slice(
              (pagination.current - 1) * pagination.pageSize,
              (pagination.current - 1) * pagination.pageSize +
                pagination.pageSize
            )"
            :key="i1"
            :style="{
              'flex-basis':
                imgData.length == 4 || imgData.length == 2 ? '45%' : '30%'
            }"
          >
            <img alt="企业荣誉" :src="item.img" v-if="i1 % 2 == 1" />
            <div class="content-msg" v-html="item.content"></div>
            <img alt="企业荣誉" :src="item.img" v-if="i1 % 2 == 0" />
          </div>
        </div>

        <el-pagination
          :current-page="pagination.current"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next"
          v-if="imgData.length > 6"
        ></el-pagination>
      </template>
    </div>
  </div>
</template>

<script>
import { getIntro, getManagement, getDevelope, getHonor } from '@/api/current'
export default {
  data() {
    return {
      navData: [
        { value: '企业简介' },
        { value: '领导团队' },
        { value: '组织架构' },
        { value: '发展历程' },
        { value: '企业荣誉' }
      ],
      isActive: 0,
      isShow: 0,
      isAnima: false,
      isYear: {
        yearOne: true,
        yearTwo: true,
        yearThree: true,
        yearFour: true,
        yearFive: true
      },
      isActiveYear: null,
      imgData: [],
      pagination: {
        total: 0,
        pageSize: 6,
        current: 1
      },
      content: '',
      teamImg: '',
      develope: []
    }
  },
  //监听路由
  watch: {
    $route: function(val) {
      let name = val.query.routerPath
      this.routerName(name)
    }
  },
  created() {
    this.init()
    this.getImg()
    this.getYear()
    this.getHonors()
  },
  mounted() {
    let name = this.$route.query.routerPath
    this.routerName(name)
    sessionStorage.setItem('bannerHeight', this.$refs.imgHeight.clientHeight)
  },
  methods: {
    // 企业简介
    init() {
      getIntro()
        .then(res => {
          this.content = res.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    //组织架构
    getImg() {
      getManagement()
        .then(res => {
          this.teamImg = res.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 发展历程
    getYear() {
      getDevelope()
        .then(res => {
          this.develope = res.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    //企业荣誉
    getHonors() {
      getHonor()
        .then(res => {
          this.imgData = res.data
          this.pagination.total = res.data.length
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 切换样式
    handleClick(index) {
      this.isActive = index
      this.isShow = index
      if (this.isShow !== 0) {
        this.isAnima = false
      } else {
        this.isAnima = true
      }
    },
    handerYear(num) {
      this.develope[num].btn = !this.develope[num].btn
    },
    routerName(name) {
      switch (name) {
        case 'fzlc':
          this.isShow = 3
          this.isActive = 3
          break
        case 'ldtd':
          this.isShow = 1
          this.isActive = 1
          break
        case 'zzjg':
          this.isShow = 2
          this.isActive = 2
          break
        case 'qyry':
          this.isShow = 4
          this.isActive = 4
          break
        case 'qyjj':
          this.isShow = 0
          this.isActive = 0
          break
      }
      if (this.isShow === 0) {
        this.isAnima = true
      }
    },
    //分页
    handleCurrentChange(val) {
      this.pagination.current = val
    }
  }
}
</script>

<style lang="scss" scope>
.about-Pn {
  .back-img {
    background-image: url('../../assets/image/about.png');
    margin-top: -75px;

    position: relative;
    .title-nav {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      // width: 1200px;
      width: 85%;
      margin: auto;
      height: 65px;
      line-height: 65px;
      font-size: 16px;
      .el-row {
        background: #013165;
        .el-col {
          margin-left: 30px;
          color: rgba(255, 255, 255, 1);
          cursor: pointer;
          text-align: center;
        }
        .active {
          color: rgba(255, 255, 255, 1);
          background: rgba(13, 126, 248, 1);
          color: #fff;
        }
      }
    }
  }
  .aboutus {
    text-align: start;
    text-align: initial;
    position: relative;
    // width: 85%;
    margin: 30px auto;
    .about-msg {
      width: 1350px;
      margin: 100px auto;
      display: flex;
      .img-qy {
        width: 890px;
        height: 593px;
      }
      .content {
        height: 515px;
        background: rgba(247, 249, 255, 1);
        padding: 25px 50px;
        z-index: 99;
        margin-left: -246px;
        margin-top: 17px;
        text-align: initial;
        h2 {
          font-size: 24px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin-top: 25px;
        }
        .line {
          width: 19px;
          height: 5px;
          background: rgba(13, 126, 248, 1);
        }
        // p {
        //   text-indent: 30px;
        //   line-height: 35px;
        //   font-size: 14px;
        //   font-weight: 400;
        //   color: rgba(85, 85, 85, 1);
        // }
        /deep/.first {
          // margin-top: 30px;
          p {
            line-height: 35px !important;
            font-size: 14px !important;
            font-weight: 400 !important;
            color: rgba(85, 85, 85, 1) !important;
            span {
              line-height: 35px !important;
              font-size: 14px !important;
              font-weight: 400 !important;
              color: rgba(85, 85, 85, 1) !important;
            }
          }
        }
      }
    }
    .team-group {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto;
      flex-direction: column;
    }

    // .group-item {
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   min-width: 55%;
    //   max-width: 55%;
    //   box-shadow: 0px 8px 46px 4px rgba(207, 207, 207, 0.3);
    //   margin: 80px 30px;
    //   height: 280px;
    //   // img {
    //   //   height: 270px;
    //   // }
    // }

    // .job-name {
    //   padding: 25px;
    //   // margin-left: 210px;
    //   font-size: 24px;
    //   font-weight: 500;
    //   color: rgba(51, 51, 51, 1);
    //   // width: 55%;
    //   .post {
    //     font-size: 18px;
    //     font-weight: 400;
    //     color: rgba(13, 126, 248, 1);
    //     margin-left: 30px;
    //   }
    //   p {
    //     margin-top: 35px;
    //     font-size: 14px;
    //     font-weight: 400;
    //     color: #333333;
    //     line-height: 27px;
    //     // width: 311px;
    //   }
    // .team-group {
    //   display: flex;
    //   flex-wrap: wrap;
    //   width: 85%;
    .group-item {
      position: relative;
      justify-content: center;
      align-items: center;
      height: 250px;
      box-shadow: 0px 8px 46px 4px rgba(207, 207, 207, 0.3);
      margin: 80px 58px 50px 80px;
      min-width: 50%;
      max-width: 50%;

      img {
        position: absolute;
        height: 280px;
        top: -31px;
        left: 20px;
      }
      .job-name {
        text-align: initial;
        padding: 25px;
        margin-left: 210px;
        font-size: 24px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        width: 65%;
        .post {
          font-size: 18px;
          font-weight: 400;
          color: rgba(13, 126, 248, 1);
          margin-left: 30px;
        }
        p {
          margin-top: 35px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 27px;
          // width: 311px;
        }
      }
    }
    // }
    // }
    .img-line {
      text-align: center;
      margin: 50px 0;
      img {
        width: 1200px;
      }
    }
    .img-box {
      display: flex;
      box-shadow: rgba(207, 207, 207, 0.3);
      // width: 85%;
      margin: 30px auto;
      font-size: 20px;
      font-weight: 500;
      color: rgba(102, 102, 102, 1);
      line-height: 35px;
      flex-wrap: wrap;
      // justify-content: space-between;
      .box-item {
        margin: 0 1.5% 25px 1.5%;
        box-shadow: 0px 8px 46px 4px rgba(207, 207, 207, 0.3);
        // flex: 1;
        img {
          width: 100%;
          height: 250px;
        }
        .content-msg {
          padding: 50px 30px;
          height: 141px;
          p {
            font-size: 20px !important;
            font-weight: 500 !important;
            color: rgba(102, 102, 102, 1) !important;
            span {
              font-size: 20px !important;
              font-weight: 500 !important;
              color: rgba(102, 102, 102, 1) !important;
            }
          }
        }
      }
    }

    .time-line {
      position: relative;
      width: 660px;
      margin: 30px auto;
    }
    .time-line-div {
      position: relative;
      min-height: 75px;
    }
    .time-line-div .timeDate {
      position: absolute;
      left: 0;
      color: #333333;
      line-height: 34px;
    }
    .time-line-div .circular {
      position: absolute;
      left: 100px;
      width: 15px;
      height: 15px;
      top: 10px;
      background: #0d7ef8;
      border-radius: 50%;
      z-index: 10;
    }
    .time-line-div .tooptip {
      position: absolute;
      left: 65px;
      width: 80px;
      height: 35px;
      line-height: 35px;
      top: 10px;
      background: #0d7ef8;
      z-index: 10;
      text-align: center;
      color: #fff;
      font-size: 17px;
    }
    .time-line-div > .tooptip:after {
      top: 100%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-top-color: #0d7ef8;
      border-width: 10px;
      top: 35px;
      left: 33px;
    }
    .yearCss > .tooptip:after {
      content: '';
      position: absolute;
      left: 80px;
      top: 11px;
      width: 0;
      height: 0;
      border-width: 10px;
      border-top: 7px solid transparent;
      border-bottom: 7px solid transparent;
      border-left: 7px solid #0d7ef8;
    }

    .time-line-div .msg {
      position: absolute;
      left: 150px;
      top: 5px;
      padding: 10px;
      font-size: 0.8rem;
      color: #0d7ef8;
      font-size: 17px;
    }
    .time-line-div .message {
      position: absolute;
      left: 150px;
      padding: 10px;
      background: #fff;
      font-size: 0.8rem;
      color: #333;
      box-shadow: 0px 4px 20px 0px rgba(13, 126, 248, 0.15);
    }
    .time-line-div .red_msg {
      background: #0d7ef8;
      color: #fff;
    }
    .time-line-div > .message:after {
      right: 100%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-right-color: #0d7ef8;
      opacity: 0.1;
      border-width: 10px;
      top: 10px;
    }

    .img-dotted {
      position: absolute;
      height: 100%;
      top: 10px;
      z-index: 1;
      width: 2px;
      height: 100%;
      background: rgba(13, 126, 248, 1);
      opacity: 0.6;
      left: 107px;
    }
    .time-line-detail > p {
      margin-left: 30px;
      margin-bottom: 10px;
    }
    .right-css {
      opacity: 0;
      transform: translate(-180px, 200px);
      transition: all 1s ease;
    }
    .anima {
      opacity: 1;
      transform: translate(0px, 0px);
    }
  }
  .el-pagination {
    text-align: center;
  }
}

::-webkit-scrollbar {
  width: 0px;
  height: 16px;
  background-color: #f5f5f5;
  border-radius: 4px;
}
</style>
